import { useEffect, useState } from 'react';
import Page from '../../../components/page/Page';
import Header from '../../../components/user/Header';
import { useUserCore } from '../../../../core/modules/user';
import useThemeMediaQuery from '../../../../core/hooks/useThemeMediaQuery';
import { useParams } from 'react-router-dom';
import { Tab, Tabs } from '@mui/material';
import BasicInfoTab from '../../../components/user/tabs/BasicInfoTab';
import { useTranslation } from 'react-i18next';
import { useMeCore } from '../../../../core/modules/me';
import { useNavigationCore } from '../../../../core/router/navigation';
import CompaniesDialog from '../../../components/user/CompaniesDialog';

const User = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { user: meUser } = useMeCore();
  const { getUser, user } = useUserCore();
  const { goToWelcome } = useNavigationCore();

  const [tabValue, setTabValue] = useState(0);

  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('lg'));

  useEffect(() => {
    if (!meUser?.is_superuser) {
      goToWelcome();
    }
  }, [meUser, goToWelcome]);

  useEffect(() => {
    if (id) {
      getUser(id);
    }
  }, [id, getUser]);

  return (
    <>
      <Page
        header={<Header />}
        content={
          <div className="w-full h-full bg-white">
            <Tabs
              value={tabValue}
              onChange={(_e, v) => setTabValue(v)}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons="auto"
              classes={{ root: 'w-full border-b-1' }}
            >
              <Tab className="h-64" label={t('user.tab.info')} />
              {user?.is_superuser ? (
                <Tab className="h-64" label="Compañías" />
              ) : null}
            </Tabs>
            <div className="p-16 sm:p-24 bg-white">
              <div className={tabValue !== 0 ? 'hidden' : ''}>
                <BasicInfoTab />
              </div>
            </div>
          </div>
        }
        scroll={isMobile ? 'normal' : 'content'}
      />
      <CompaniesDialog />
    </>
  );
};

export default User;
